package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.CheckCircleW500Rounded: ImageVector
    get() {
        if (_checkCircleW500Rounded != null) {
            return _checkCircleW500Rounded!!
        }
        _checkCircleW500Rounded = Builder(name = "CheckCircleW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveToRelative(423.28f, 543.63f)
                lineToRelative(-79.78f, -79.78f)
                quadToRelative(-12.43f, -12.44f, -31.35f, -12.44f)
                quadToRelative(-18.91f, 0.0f, -31.35f, 12.44f)
                quadToRelative(-12.43f, 12.43f, -12.31f, 31.35f)
                quadToRelative(0.12f, 18.91f, 12.55f, 31.34f)
                lineToRelative(110.18f, 110.18f)
                quadToRelative(13.76f, 13.67f, 32.11f, 13.67f)
                quadToRelative(18.34f, 0.0f, 32.02f, -13.67f)
                lineTo(677.76f, 414.3f)
                quadToRelative(12.44f, -12.43f, 12.44f, -31.22f)
                quadToRelative(0.0f, -18.8f, -12.44f, -31.23f)
                quadToRelative(-12.43f, -12.44f, -31.35f, -12.44f)
                quadToRelative(-18.91f, 0.0f, -31.34f, 12.44f)
                lineTo(423.28f, 543.63f)
                close()
                moveTo(480.0f, 888.13f)
                quadToRelative(-84.91f, 0.0f, -159.34f, -32.12f)
                quadToRelative(-74.44f, -32.12f, -129.5f, -87.17f)
                quadToRelative(-55.05f, -55.06f, -87.17f, -129.5f)
                quadTo(71.87f, 564.91f, 71.87f, 480.0f)
                reflectiveQuadToRelative(32.12f, -159.34f)
                quadToRelative(32.12f, -74.44f, 87.17f, -129.5f)
                quadToRelative(55.06f, -55.05f, 129.5f, -87.17f)
                quadToRelative(74.43f, -32.12f, 159.34f, -32.12f)
                reflectiveQuadToRelative(159.34f, 32.12f)
                quadToRelative(74.44f, 32.12f, 129.5f, 87.17f)
                quadToRelative(55.05f, 55.06f, 87.17f, 129.5f)
                quadToRelative(32.12f, 74.43f, 32.12f, 159.34f)
                reflectiveQuadToRelative(-32.12f, 159.34f)
                quadToRelative(-32.12f, 74.44f, -87.17f, 129.5f)
                quadToRelative(-55.06f, 55.05f, -129.5f, 87.17f)
                quadTo(564.91f, 888.13f, 480.0f, 888.13f)
                close()
                moveTo(480.0f, 797.13f)
                quadToRelative(133.04f, 0.0f, 225.09f, -92.04f)
                quadToRelative(92.04f, -92.05f, 92.04f, -225.09f)
                quadToRelative(0.0f, -133.04f, -92.04f, -225.09f)
                quadToRelative(-92.05f, -92.04f, -225.09f, -92.04f)
                quadToRelative(-133.04f, 0.0f, -225.09f, 92.04f)
                quadToRelative(-92.04f, 92.05f, -92.04f, 225.09f)
                quadToRelative(0.0f, 133.04f, 92.04f, 225.09f)
                quadToRelative(92.05f, 92.04f, 225.09f, 92.04f)
                close()
                moveTo(480.0f, 480.0f)
                close()
            }
        }
        .build()
        return _checkCircleW500Rounded!!
    }

private var _checkCircleW500Rounded: ImageVector? = null
